import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as globals from '../training/globals';
import { Folder } from '../models/folder.model';

const baseUrl = `${environment.apis.connect}/${globals.CONNECT}`;

@Injectable({
  providedIn: 'root',
})

export class ConnectService {
  constructor(
    private http: HttpClient) { }

  getAccountsByUser(user_email: string): Observable<any> {
    return this.http.get(`${baseUrl}/${globals.GET_ACCOUNTS_BY_USER}?${globals.USER_EMAIL}=${user_email}`);
  }

  assignResources(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.ASSIGN_RESOURCES}`, data);
  }

  createResources(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.CREATE_RESOURCES}`, data);
  }

  cleanupResources(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.CLEANUP_RESOURCES}`, data);
  }

  updateStudent(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.UPDATE_STUDENT}`, data);
  }

  resendInvite(id: number): Observable<any> {
    return this.http.get(`${baseUrl}/${globals.RESEND_INVITE}/${id}`);
  }

  forceDelete(id: number): Observable<any> {
    return this.http.delete(`${baseUrl}/${globals.FORCE_DELETE}/${id}`);
  }

  getActiveFolders(refresh: boolean): Observable<Folder[]> {
    return this.http.get<Folder[]>(`${baseUrl}/${globals.FOLDERS}?refresh=${refresh}`);
  }

  cleanupActiveFolders(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.FOLDERS}/${globals.CLEANUP_RESOURCES}`, data);
  }
}
